import { useEffect, useState } from 'react';
import { Select } from 'antd';
import CustomerService from "services/customer"
import { formatCurrency } from "utils/number"

const service = new CustomerService();
const CustomerPicker = (props) => {
    const [customers, setCustomers] = useState([]);
    useEffect(() => {
        loadData();
    }, []);
    const loadData = async () => {
        var lst = await service.list({});
        setCustomers(lst);
    }

    return (


        <Select
            {...props}
            showSearch
            placeholder="Select a person"
            filterOption={(input, option) => {
                var _a;
                return (
                    (_a = option === null || option === void 0 ? void 0 : option.search_text) !== null &&
                        _a !== void 0
                        ? _a
                        : ''
                )
                    .toLowerCase()
                    .includes(input.toLowerCase());
            }}
            options={customers.map(x => ({ label: `${x.phone} ${x.full_name}`, value: x.id, search_text: x.search_text }))}
        />)
}
export default CustomerPicker;